import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { BRAND, NAV_ITEMS } from "../data/brand";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 w-full backdrop-blur-xl transition-all duration-300 ${
        scrolled
          ? "bg-white/90 border-b border-slate-200 shadow-sm"
          : "bg-white/75 border-b border-slate-200/60"
      }`}
    >
      <div className="container-90 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3">
          <img
            src={BRAND.logo}
            alt="90 Brokers Srls"
            className="h-11 w-auto"
            style={{ filter: "url(#remove-black)" }}
          />
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="font-heading font-extrabold text-slate-900 tracking-tight">
              90 Brokers
            </span>
            <span className="text-[0.68rem] uppercase tracking-[0.18em] text-slate-500 font-semibold">
              Srls · Frosinone
            </span>
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-10">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.to === "/" ? "home" : item.to.replace("/", "")}-link`}
              className={({ isActive }) =>
                `text-sm font-semibold tracking-wide transition-colors relative py-2 ${
                  isActive
                    ? "text-[color:var(--brand-blue)]"
                    : "text-slate-700 hover:text-[color:var(--brand-blue)]"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  {isActive && (
                    <span className="absolute -bottom-1 left-0 right-0 h-[2px] bg-[color:var(--brand-yellow)]" />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        {/* Mobile toggle */}
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 text-slate-900"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white" data-testid="mobile-menu">
          <nav className="container-90 py-6 flex flex-col gap-4">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`mobile-nav-${item.to === "/" ? "home" : item.to.replace("/", "")}-link`}
                className={({ isActive }) =>
                  `text-base font-semibold py-2 border-b border-slate-100 ${
                    isActive ? "text-[color:var(--brand-blue)]" : "text-slate-800"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
